<template>
    <h1>培训报名</h1>
</template>

<script>
    export default {
        name: "index"
    }
</script>

<style scoped>

</style>